<!-- eslint-disable -->
<template>
  <div class="c2m7c1_grid_container">
    <div class="c2m7c1_rule_name">
      <h3>{{ruleName}}</h3>
      <h4>{{ruleDescription}}</h4>
    </div>

    <!-- <start> assign / remove buttons -->
    <button 
      v-if="showAssignButton==true && C_canUserEditRules" 
      @click.prevent="assignRule" 
      class="c2m7c1_assign_button"
    >
      Assign
    </button>
    <button 
      v-if="showRemoveButton==true  && C_canUserEditRules" 
      @click.prevent="unassignRule" 
      class="c2m7c1_unassign_button"
      :disabled="unassigningRuleId===ruleUid"
    >
      Remove
    </button>
    <!-- </end> assign / remove buttons -->

    <!-- <start> checkboxes for selecting notification type -->
    <div class="c2m7c1_options" v-if="showNotificationTypes === true">
      <!-- <start> doghouse checkbox -->
      <label 
        :for="ruleUid + '_doghouse_checkbox'"  
        class="c2m7c1_doghouse_checkbox_label"
      >
        Doghouse
      </label>
      <input
        v-model="DV_selectedNotificationTypes "
        :id="ruleUid + '_doghouse_checkbox'"
        value="c"
        class="c2m7c1_doghouse_checkbox" 
        type="checkbox"
        :disabled="!C_canUserEditRules"
      >
      <!-- </end> doghouse checkbox -->

      <!-- <start> instant email checkbox -->
      <label 
        :for="ruleUid + '_instant_email_checkbox'" 
        class="c2m7c1_instant_email_checkbox_label"
      >
        Instant Email
      </label>
      <input
        v-model="DV_selectedNotificationTypes" 
        :id="ruleUid + '_instant_email_checkbox'"
        value="a" class="c2m7c1_instant_email_checkbox"
        type="checkbox"
        :disabled="!C_canUserEditRules"
      >
      <!-- </end> instant email checkbox -->

      <!-- removed until fixed / fully implemented in back-end -->
      <!-- <start> dailly report checkbox -->
      <!-- <label 
        :for="ruleUid + '_daily_report_checkbox'"
        class="c2m7c1_daily_report_checkbox_label"
      >
        Daily Report
      </label>
      <input
        v-model="DV_selectedNotificationTypes" 
        :id="ruleUid + '_daily_report_checkbox'" 
        value="b"
        class="c2m7c1_daily_report_checkbox" 
        type="checkbox"
      > -->
      <!-- </end> dailly report checkbox -->

      <!--<start> how long between sending instant email alerts -->
      <div
        v-if="DV_selectedNotificationTypesString !== null &&
              DV_selectedNotificationTypesString.includes('a') === true"
        class="c2m7c1_retrigger_span">
        <label class="c2m7c1_retrigger_label">
          Instant Email Retrigger time:
        </label>
        
        <select :disabled="!C_canUserEditRules" v-model="DV_actualInstantRetriggerTime">
          <option value="600"> 10 Minutes</option>
          <option value="1800"> 30 Minutes</option>
          <option value="3600"> 1 Hour</option>
          <option value="7200"> 2 Hours</option>
          <option value="14400"> 4 Hours</option>
          <option value="21600"> 6 Hours</option>
          <option value="28800"> 8 Hours</option>
          <option value="43200"> 12 Hours</option>
          <option value="57600"> 16 Hours</option>
          <option value="72000"> 20 Hours</option>
          <option value="86400"> 24 Hours</option>
        </select>
      </div>
      <!--</end> how long between sending instant email alerts -->
    </div>

    <!--<start> assigning and unassigning rule feedback --> 
    <div
      v-if="assigningRuleId && assigningRuleId === ruleUid && showAssignButton==true"
      class="c2m7c1_assigning_feedback"
    >
    </div>
    <div
      v-if="unassigningRuleId && unassigningRuleId === ruleUid"
      class="c2m7c1_unassigning_feedback"
    ></div>
    <!--</end> assigning and unassigning rule feedback -->
  
  </div>
  <!-- <end> checkboxes for selecting notificaiton type -->
</template>

<script>
/* eslint-disable */

import { bi10ModalTemplate, bi10OrgPermissions } from "../../../../watchdog_includes/base_i10_UI_mixins";

export default {
  name: "c2m7c1RuleEntry",
  mixins: [bi10ModalTemplate, bi10OrgPermissions],
  props: [
    "orgUid",
    "ruleName",
    "ruleDescription",
    "ruleUid",
    "selectedRuleUid",
    "showAssignButton",
    "showRemoveButton",
    "showNotificationTypes",
    "doghouseChecked",
    "instantChecked",
    "daillyChecked",
    "instantRetriggerTime",
    "assigningRuleId",
    "unassigningRuleId",
    "selectedGroupType"
  ],
  data: function() {
    return {
      DV_selectedNotificationTypes: [],
      DV_selectedNotificationTypesString: null,
      DV_actualInstantRetriggerTime: 3600,
    };
  },
  mounted: function() {
    const CI = this
    CI.$nextTick(function() {
      this.bi10GetOrgPermissions(this.orgUid);
      CI.setInitialNotificationTypes();
      if (typeof CI.instantRetriggerTime === "number") {
        CI.DV_actualInstantRetriggerTime = CI.instantRetriggerTime
      }
    });
  },
  computed: {
    C_canUserEditRules() {
      if (this.selectedGroupType === 'personal') {return true;}
      return this.userPermissions.includes('a') || this.userPermissions.includes('u');
    }
  },
  methods: {
    assignRule: function() {
      const CI = this
      CI.$emit("event-assign-rule", [CI.ruleUid, "c", 600])
    },
    unassignRule: function() {
      const CI = this
      CI.$emit("event-unassign-rule", CI.ruleUid)
    },
    setInitialNotificationTypes() {
      const CI = this
      const newTypesList = []
      let newTypesString = ""
      if (CI.doghouseChecked === true) {
        newTypesList.push("c")
        newTypesString += "c"
      }
      if (CI.instantChecked === true) {
        newTypesList.push("a")
        newTypesString += "a"
      }
      if (CI.daillyChecked === true) {
        newTypesList.push("b")
        newTypesString += "b"
      }
      CI.DV_selectedNotificationTypesString = newTypesString
      CI.DV_selectedNotificationTypes = newTypesList
    },
    updateRuleJoin() {
      const CI = this
      CI.$emit("event-assign-rule", [
        CI.ruleUid,
        CI.DV_selectedNotificationTypesString,
        CI.DV_actualInstantRetriggerTime,
      ])
    },
  },
  watch: {
    DV_actualInstantRetriggerTime() {
      const CI = this
      if (CI.DV_actualInstantRetriggerTime !== CI.instantRetriggerTime) {
        CI.updateRuleJoin()
      }
    },
    DV_selectedNotificationTypes() {
      const CI = this
      let newTypesString = ''
      for(let index in CI.DV_selectedNotificationTypes) {
        newTypesString += CI.DV_selectedNotificationTypes[index]
      }
      if(CI.DV_selectedNotificationTypesString !== newTypesString) {
        CI.DV_selectedNotificationTypesString = newTypesString
        CI.updateRuleJoin()
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/p2Dashboard/p2s1MyOrganizations/c2m7/c2m7c1RuleEntry.vue